
export const ResponseCode = {
    NONE: "None",
    SUCCESS: "Success",
    FAIL: "Fail",
    NODATA: "NoData",
    INFO: "Info",
}